import { createAsyncSelectors } from '../../lib/selectors';
import { useAction } from '../useAction';
import { useSonarSelector } from '../useSonarSelector';
import { Import, importsActions } from '@sonar-software/sonar-imports';
import { useCallback, useEffect } from 'react';

export interface UseImportLogsResult {
	refresh: () => void;
	status?: Import | null;
}

const importStatusSelectors = createAsyncSelectors((state) => state.imports.byId.status.get);

export function useImportStatus(importId?: number | null, latestLogs?: number): UseImportLogsResult {
	const status = useSonarSelector(importStatusSelectors.data);

	const loadStatus = useAction(importsActions.requestGetImportsByIdStatus);

	const refresh = useCallback(() => {
		if (!importId) {
			return;
		}

		loadStatus({
			importId,
			latest: latestLogs
		});
	}, [ importId, latestLogs, loadStatus ]);

	useEffect(() => {
		if (importId) {
			refresh();
		}
	}, [ importId, refresh ]);

	return {
		refresh,
		status
	};
}
